import { useMemo, useCallback, useReducer, createContext } from 'react';

export const RegisterContext = createContext();

const reducer = (state, action) => {
  switch (action.type) {
    case 'form':
      return { ...state, form: action.payload };
  }
};

export const RegisterProvider = ({ id, scheme, children }) => {
  const [state, dispatch] = useReducer(reducer, { form: { isValid: false, errors: [], data: {} } });
  const user = useMemo(
    () => ({ ...state.form.data, nameIdentifier: id, provider: scheme }),
    [state.form.data, id, scheme],
  );

  const handleForm = useCallback(form => dispatch({ type: 'form', payload: form }), [dispatch]);

  const context = useMemo(
    () => ({
      user,
      handleForm,
      isValid: state.form.isValid,
      errors: state.form.errors,
    }),
    [user, handleForm, state.form.isValid, state.form.errors],
  );

  return <RegisterContext.Provider value={context}>{children}</RegisterContext.Provider>;
};
